/*
  OyeGifts FNP-Style Delivery Promise
  File: assets/og-delivery-promise-badges.js

  IMPORTANT
  - Nothing is shown on the product image.
  - Delivery promise is shown BELOW PRICE, like FNP.
  - Collection / Search / Homepage + Product Page supported.
  - Express tag gets priority if both express + courier tags exist.
  - India timezone: Asia/Kolkata.

  EXPRESS
  12:00 AM–7:59 AM  => Same Day        | By 12 PM
  8:00 AM–7:59 PM   => Same Day        | By current hour + 3
  8:00 PM onward    => Tomorrow        | By 12 PM

  COURIER
  Before 8 PM       => Dispatch Today
  8 PM onward       => Dispatch Tomorrow
*/

(function () {
  "use strict";

  var STYLE_ID = "oy-delivery-promise-below-price-css";
  var ROW_CLASS = "oy-delivery-promise-row";

  var TAG_CACHE_KEY = "oy_delivery_tag_cache_v10";
  var TAG_CACHE_TTL = 30 * 60 * 1000;

  var TAG_CACHE = loadTagCache();
  var FETCH_PROMISES = Object.create(null);

  var observerTimer = null;
  var minuteTimer = null;

  /* =========================================================
     CSS
  ========================================================= */

  function injectCSSOnce() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      .${ROW_CLASS}{
        display:flex!important;
        align-items:center!important;
        justify-content:space-between!important;
        gap:8px!important;
        width:100%!important;
        min-width:0!important;
        margin:6px 0 2px!important;
        padding:0!important;
        font-family:inherit!important;
        line-height:1.2!important;
        box-sizing:border-box!important;
      }

      .${ROW_CLASS}__left,
      .${ROW_CLASS}__right{
        display:inline-flex!important;
        align-items:center!important;
        min-width:0!important;
        white-space:nowrap!important;
      }

      .${ROW_CLASS}__left{
        gap:4px!important;
        color:#ef7d00!important;
        font-size:12.5px!important;
        font-weight:700!important;
        font-style:italic!important;
      }

      .${ROW_CLASS}.is-tomorrow .${ROW_CLASS}__left{
        color:#0f766e!important;
        font-style:normal!important;
      }

      .${ROW_CLASS}.is-courier .${ROW_CLASS}__left{
        color:#5f6368!important;
        font-style:normal!important;
      }

      .${ROW_CLASS}__right{
        gap:4px!important;
        margin-left:auto!important;
        color:#444!important;
        font-size:11px!important;
        font-weight:600!important;
      }

      .${ROW_CLASS}__icon{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:15px!important;
        height:15px!important;
        flex:0 0 15px!important;
        font-size:13px!important;
        line-height:1!important;
      }

      .${ROW_CLASS}__truck{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:15px!important;
        height:15px!important;
        flex:0 0 15px!important;
        color:#6b7280!important;
      }

      .${ROW_CLASS}__truck svg{
        display:block!important;
        width:15px!important;
        height:15px!important;
        fill:none!important;
        stroke:currentColor!important;
        stroke-width:1.8!important;
        stroke-linecap:round!important;
        stroke-linejoin:round!important;
      }

      .${ROW_CLASS}__clock{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:14px!important;
        height:14px!important;
        flex:0 0 14px!important;
        color:#555!important;
      }

      .${ROW_CLASS}__clock svg{
        display:block!important;
        width:14px!important;
        height:14px!important;
        fill:none!important;
        stroke:currentColor!important;
        stroke-width:1.75!important;
        stroke-linecap:round!important;
        stroke-linejoin:round!important;
      }

      @media(min-width:750px){
        .${ROW_CLASS}{
          margin-top:7px!important;
        }

        .${ROW_CLASS}__left{
          font-size:12.5px!important;
        }

        .${ROW_CLASS}__right{
          font-size:11.5px!important;
        }
      }

      @media(max-width:749px){
        .${ROW_CLASS}{
          gap:5px!important;
          margin:5px 0 1px!important;
        }

        .${ROW_CLASS}__left{
          gap:3px!important;
          font-size:13px!important;
        }

        .${ROW_CLASS}__right{
          gap:3px!important;
          font-size:11.5px!important;
        }

        .${ROW_CLASS}__icon{
          width:13px!important;
          height:13px!important;
          flex-basis:13px!important;
          font-size:12px!important;
        }

        .${ROW_CLASS}__truck,
        .${ROW_CLASS}__truck svg{
          width:13px!important;
          height:13px!important;
        }

        .${ROW_CLASS}__truck{
          flex-basis:13px!important;
        }

        .${ROW_CLASS}__clock,
        .${ROW_CLASS}__clock svg{
          width:12px!important;
          height:12px!important;
        }

        .${ROW_CLASS}__clock{
          flex-basis:12px!important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  /* =========================================================
     REMOVE ANY OLD IMAGE BADGES
  ========================================================= */

  function removeOldImageBadges(scope) {
    var root = scope || document;

    root
      .querySelectorAll(
        ".og-product-badge,.oy-delivery-ribbon-badge"
      )
      .forEach(function (el) {
        el.remove();
      });

    root
      .querySelectorAll(
        ".og-product-badge-host,.oy-delivery-ribbon-host,[data-oy-delivery-ribbon-host]"
      )
      .forEach(function (el) {
        el.classList.remove(
          "og-product-badge-host",
          "oy-delivery-ribbon-host"
        );
        el.removeAttribute("data-oy-delivery-ribbon-host");
      });
  }

  /* =========================================================
     TAG CACHE
  ========================================================= */

  function loadTagCache() {
    try {
      var raw = sessionStorage.getItem(TAG_CACHE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function saveTagCache() {
    try {
      sessionStorage.setItem(TAG_CACHE_KEY, JSON.stringify(TAG_CACHE));
    } catch (e) {}
  }

  function getCachedTags(handle) {
    var entry = TAG_CACHE[handle];

    if (!entry || !entry.tags || !entry.ts) return null;

    if (Date.now() - entry.ts > TAG_CACHE_TTL) {
      delete TAG_CACHE[handle];
      saveTagCache();
      return null;
    }

    return entry.tags;
  }

  function setCachedTags(handle, tags) {
    TAG_CACHE[handle] = {
      tags: tags || [],
      ts: Date.now()
    };

    saveTagCache();
  }

  function normalizeTags(tags) {
    var list = [];

    if (Array.isArray(tags)) {
      list = tags;
    } else if (typeof tags === "string") {
      list = tags.split(",");
    } else if (tags) {
      list = [String(tags)];
    }

    return list.map(function (tag) {
      return String(tag || "").trim().toLowerCase();
    });
  }

  function getDeliveryType(tags) {
    var cleanTags = normalizeTags(tags);

    if (cleanTags.indexOf("express") !== -1) return "express";
    if (cleanTags.indexOf("courier") !== -1) return "courier";

    return null;
  }

  function fetchProductTags(handle) {
    if (!handle) return Promise.resolve([]);

    var cached = getCachedTags(handle);

    if (cached) return Promise.resolve(cached);
    if (FETCH_PROMISES[handle]) return FETCH_PROMISES[handle];

    FETCH_PROMISES[handle] = fetch(
      "/products/" + encodeURIComponent(handle) + ".js",
      { credentials: "same-origin" }
    )
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        var tags = product && product.tags ? product.tags : [];

        setCachedTags(handle, tags);
        delete FETCH_PROMISES[handle];

        return tags;
      })
      .catch(function () {
        delete FETCH_PROMISES[handle];
        return [];
      });

    return FETCH_PROMISES[handle];
  }

  /* =========================================================
     INDIA TIME
  ========================================================= */

  function getIndiaTime() {
    try {
      var parts = new Intl.DateTimeFormat("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23"
      }).formatToParts(new Date());

      var hour = 0;
      var minute = 0;

      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === "hour") {
          hour = parseInt(parts[i].value, 10);
        }

        if (parts[i].type === "minute") {
          minute = parseInt(parts[i].value, 10);
        }
      }

      return {
        hour: hour,
        minute: minute
      };
    } catch (e) {
      var now = new Date();
      var utc = now.getTime() + now.getTimezoneOffset() * 60000;
      var ist = new Date(utc + 330 * 60000);

      return {
        hour: ist.getHours(),
        minute: ist.getMinutes()
      };
    }
  }

  function hourText(hour) {
    hour = hour % 24;

    var suffix = hour >= 12 ? "PM" : "AM";
    var hour12 = hour % 12 || 12;

    return hour12 + " " + suffix;
  }

  function getDeliveryData(type) {
    var ist = getIndiaTime();
    var hour = ist.hour;

    if (type === "express") {
      if (hour >= 20) {
        return {
          left: "Tomorrow",
          right: "By 12 PM",
          icon: "→",
          tomorrow: true,
          courier: false
        };
      }

      if (hour < 8) {
        return {
          left: "Same Day",
          right: "By 12 PM",
          icon: "☀",
          tomorrow: false,
          courier: false
        };
      }

      return {
        left: "Same Day",
        right: "By " + hourText(hour + 3),
        icon: "☀",
        tomorrow: false,
        courier: false
      };
    }

    if (type === "courier") {
      return {
        left: hour >= 20 ? "Dispatched by Tomorrow" : "Dispatched by Today",
        right: "",
        icon: "",
        tomorrow: hour >= 20,
        courier: true
      };
    }

    return null;
  }

  /* =========================================================
     HTML
  ========================================================= */

  function clockIcon() {
    return (
      '<span class="' + ROW_CLASS + '__clock" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" focusable="false">' +
          '<circle cx="12" cy="12" r="8.25"></circle>' +
          '<path d="M12 7.7v4.7l3.15 1.9"></path>' +
          '<circle cx="12" cy="12" r="0.7" fill="currentColor" stroke="none"></circle>' +
        '</svg>' +
      '</span>'
    );
  }

  function getRowHTML(type, extraClass) {
    var data = getDeliveryData(type);

    if (!data) return "";

    var classes = ROW_CLASS;

    if (data.tomorrow) classes += " is-tomorrow";
    if (data.courier) classes += " is-courier";
    if (extraClass) classes += " " + extraClass;

    var rightHTML = "";

    if (data.right) {
      rightHTML =
        '<span class="' + ROW_CLASS + '__right">' +
          clockIcon() +
          '<span data-oy-delivery-right>' + data.right + '</span>' +
        '</span>';
    }

    var leftIconHTML = data.courier
      ? (
          '<span class="' + ROW_CLASS + '__truck" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" focusable="false">' +
              '<path d="M3.5 6.5h10v9h-10z"></path>' +
              '<path d="M13.5 10h3.8l3.2 3.1v2.4h-7z"></path>' +
              '<circle cx="7.2" cy="17.3" r="1.7"></circle>' +
              '<circle cx="17.4" cy="17.3" r="1.7"></circle>' +
            '</svg>' +
          '</span>'
        )
      : (
          '<span class="' + ROW_CLASS + '__icon" aria-hidden="true">' +
            data.icon +
          '</span>'
        );

    return (
      '<div class="' + classes + '" data-oy-delivery-type="' + type + '">' +
        '<span class="' + ROW_CLASS + '__left">' +
          leftIconHTML +
          '<span data-oy-delivery-left>' + data.left + '</span>' +
        '</span>' +
        rightHTML +
      '</div>'
    );
  }

  /* =========================================================
     HELPERS
  ========================================================= */

  function getProductHandleFromLink(link) {
    if (!link) return null;

    var href = link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^\/?#]+)/i);

    return match ? decodeURIComponent(match[1]) : null;
  }

  function getProductPageHandle() {
    var match = (location.pathname || "").match(
      /\/products\/([^\/?#]+)/i
    );

    return match ? decodeURIComponent(match[1]) : null;
  }

  function isInsideExcludedArea(element) {
    return !!(
      element &&
      element.closest(
        "header,nav,footer,.header,.footer,.menu-drawer,.drawer,.cart-drawer,.cart-notification,.cart"
      )
    );
  }

  function findCardCandidates() {
    return document.querySelectorAll(
      "[data-card],.ogp,.card-wrapper,.card,.product-card,.grid__item,.product-grid-item,.boost-pfs-filter-product-item,.product-item"
    );
  }

  function findProductLink(card) {
    return card
      ? card.querySelector('a[href*="/products/"]')
      : null;
  }

  /*
    Prefer the full price row/container so the delivery row
    appears neatly UNDER the whole price area.
  */
  function findPriceElementInCard(card) {
    return card.querySelector(
      ".ogpr," +
      ".card-information .price," +
      ".card__information .price," +
      ".product-card__price," +
      ".boost-pfs-filter-product-item-price," +
      ".product-item__price," +
      ".price"
    );
  }

  function findProductInfoBlock(card) {
    return card.querySelector(
      ".oginfo," +
      ".card-information," +
      ".card__information," +
      ".product-card__info," +
      ".card-information__wrapper," +
      ".product-item__info"
    );
  }

  function findPriceElementInPDP() {
    return document.querySelector(
      ".product__info-container .price," +
      ".product__info-wrapper .price," +
      ".product-single__price," +
      ".price.price--large," +
      ".product__price," +
      ".price"
    );
  }

  /* =========================================================
     COLLECTION / SEARCH / HOME
  ========================================================= */

  function removeCardRows(card) {
    if (!card) return;

    card
      .querySelectorAll("." + ROW_CLASS + ":not(.oy-pdp)")
      .forEach(function (row) {
        row.remove();
      });

    /*
      Also remove the OLD text implementation if still present.
    */
    card
      .querySelectorAll(".oy-delivery-badge-wrap:not(.oy-pdp)")
      .forEach(function (row) {
        row.remove();
      });
  }

  function applyRowInCard(card, type, handle) {
    if (!card || isInsideExcludedArea(card)) return;

    removeCardRows(card);

    if (!type) {
      card.dataset.oyDeliveryHandle = handle || "";
      card.dataset.oyDeliveryType = "";
      card.dataset.oyDeliveryReady = "1";
      return;
    }

    var priceEl = findPriceElementInCard(card);
    var infoBlock = findProductInfoBlock(card);
    var html = getRowHTML(type, "");

    if (priceEl) {
      priceEl.insertAdjacentHTML("afterend", html);
    } else if (infoBlock) {
      infoBlock.insertAdjacentHTML("beforeend", html);
    }

    card.dataset.oyDeliveryHandle = handle || "";
    card.dataset.oyDeliveryType = type;
    card.dataset.oyDeliveryReady = "1";
  }

  function enhanceCards() {
    var cards = findCardCandidates();

    Array.prototype.forEach.call(cards, function (card) {
      if (!card || isInsideExcludedArea(card)) return;

      var productLink = findProductLink(card);
      var handle = getProductHandleFromLink(productLink);

      if (!handle) return;

      var existingHandle = card.dataset.oyDeliveryHandle || "";
      var ready = card.dataset.oyDeliveryReady === "1";
      var rowExists = !!card.querySelector(
        "." + ROW_CLASS + ":not(.oy-pdp)"
      );

      if (
        existingHandle === handle &&
        ready &&
        (
          rowExists ||
          card.dataset.oyDeliveryType === ""
        )
      ) {
        return;
      }

      card.dataset.oyDeliveryHandle = handle;

      fetchProductTags(handle).then(function (tags) {
        if (card.dataset.oyDeliveryHandle !== handle) return;

        var type = getDeliveryType(tags);

        applyRowInCard(card, type, handle);
      });
    });
  }

  /* =========================================================
     PRODUCT PAGE
  ========================================================= */

  function removePDPRow() {
    document
      .querySelectorAll(
        "." + ROW_CLASS + ".oy-pdp,.oy-delivery-badge-wrap.oy-pdp"
      )
      .forEach(function (row) {
        row.remove();
      });
  }

  function applyRowInPDP(type) {
    removePDPRow();

    if (!type) return;

    var priceEl = findPriceElementInPDP();
    if (!priceEl) return;

    priceEl.insertAdjacentHTML(
      "afterend",
      getRowHTML(type, "oy-pdp")
    );
  }

  function enhancePDP() {
    if (location.pathname.indexOf("/products/") === -1) {
      removePDPRow();
      return;
    }

    var handle = getProductPageHandle();

    if (!handle) return;

    fetchProductTags(handle).then(function (tags) {
      applyRowInPDP(getDeliveryType(tags));
    });
  }

  /* =========================================================
     MINUTE REFRESH
  ========================================================= */

  function refreshVisibleRows() {
    document
      .querySelectorAll(
        "." + ROW_CLASS + "[data-oy-delivery-type]"
      )
      .forEach(function (row) {
        var type = row.getAttribute("data-oy-delivery-type");
        var data = getDeliveryData(type);

        if (!data) return;

        var left = row.querySelector("[data-oy-delivery-left]");
        var right = row.querySelector("[data-oy-delivery-right]");

        row.classList.toggle("is-tomorrow", data.tomorrow);
        row.classList.toggle("is-courier", data.courier);

        if (left) left.textContent = data.left;
        if (right) right.textContent = data.right;
      });
  }

  /* =========================================================
     INIT
  ========================================================= */

  function render() {
    injectCSSOnce();
    removeOldImageBadges(document);
    enhanceCards();
    enhancePDP();
    refreshVisibleRows();
  }

  function scheduleEnhancements() {
    clearTimeout(observerTimer);

    observerTimer = setTimeout(function () {
      render();
    }, 180);
  }

  function init() {
    render();

    /*
      One delayed pass for app/theme rendered cards.
    */
    setTimeout(render, 700);

    if (minuteTimer) clearInterval(minuteTimer);

    minuteTimer = setInterval(function () {
      refreshVisibleRows();
    }, 60000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].addedNodes &&
          mutations[i].addedNodes.length
        ) {
          scheduleEnhancements();
          break;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.oyRefreshDeliveryBadges = function () {
    render();
  };
})();
